
import './NavBar.scss'
import h2ologo from './res/h2ologo.png'
import { Navbar  } from 'react-bootstrap';

function NavBar() {
    return (
        <Navbar className="navigation">
            <a href="/"><img className="navigationLogo" src={h2ologo} alt="Logo"></img></a>
            <ul className="navigationUL">
                    <li className="naviationList"><a href="/">Home</a></li>
                    <li className="naviationList"><a href="/vehicle-catalog">Catalog</a></li>
                    <li className="naviationList"><a href="/FAQ">FAQ</a></li>
                    <li className="naviationList"><a href="/Login">Sign In</a></li>
                </ul>
        </Navbar>
    )
}
export default NavBar;